var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('input',{staticClass:"d-none",attrs:{"type":"file","id":"listupload","accept":".xlsx"},on:{"change":_vm.importFile}}),_c('g-button',{staticClass:"ml-2",attrs:{"icon":"cloud_download","label":"Export List (Excel)"},on:{"onclick":function($event){return _vm.exportRooms()}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }